import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useSelector, shallowEqual } from "react-redux";
import { useRxCollection } from "rxdb-hooks";
import { addProblem } from "../../_redux/patientService";
import { patientsSlice } from "../../_redux/patientSlice";
import {useDispatch} from "react-redux";

export const Problems = () => {
  const { patientId } = useParams();
  const {actions} = patientsSlice;
  const dispatch = useDispatch();

  useEffect(()=>{
   if(patientId) {
    dispatch(actions.setSelectedPatient({patient: patientId}))
   }
  },[patientId])

  const collection = useRxCollection("problems");
  const [result, setResult] = useState([]);

  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (collection) {
      collection.getProblems(patientId, user.practice.id, (result) =>
        setResult(result)
      );
    }
  }, [patientId, collection]);

  const onAddProblem = () => {
    const problem = {
      id: "999",
      name: "Pusher Problem",
      short_desc: "Pusher Problem",
      begdate: "2022-09-22",
      enddate: "2022-09-22",
      returndate: "2022-09-22",
      destination: "Home Clinic",
      active: "ACTVE",
      type: "New",
      code: "NEW",
      favorite: true,
      created_at: "2022-09-22",
      created_by: "Aqeel",
      status: "Active",
    };
    addProblem({
      collection:"problems",
      pid: result[0].pid,
      problems: problem,
    }).then((data) => {
      console.log(data);
    });
  };

  return (
    result && (
      <div className="sm:px-6 w-full">
        <div className="bg-white py-4 md:py-7 px-4 md:px-8 xl:px-10"></div>
        <button
          onClick={() => onAddProblem()}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded"
        >
          Add Problem
        </button>
        <div className="mt-7 overflow-x-auto">
          <table className="w-full whitespace-nowrap">
            <tbody>
              <tr className="focus:outline-none h-16 border border-gray-100 rounded">
                <td className="">
                  <div className="flex items-center pl-5">
                    <p className="text-base font-medium leading-none text-black mr-2">
                      Problems History
                    </p>
                  </div>
                </td>
                <td className="pr-24">
                  <div className="flex justify-end">
                    <p className="text-base font-medium leading-none text-black ml-2">
                      Status
                    </p>
                  </div>
                </td>
                <td className="pr-24">
                  <div className="flex justify-end">
                    <p className="text-base font-medium leading-none text-black ml-2">
                      Onset Date
                    </p>
                  </div>
                </td>
              </tr>
              {result &&
                result.length &&
                result[0]?.problems.map((problem) => {
                  return (
                    <tr
                      key={problem.id}
                      className="focus:outline-none h-16 border border-gray-100 rounded"
                    >
                      <td className="">
                        <div className="flex items-center pl-5">
                          <p className="text-base font-medium leading-none text-gray-700 mr-2">
                            {`${problem.code} ${problem.name}`}
                          </p>
                        </div>
                      </td>
                      <td className="pr-24">
                        <div className="flex justify-end">
                          <p className="text-sm leading-none text-gray-600 ml-2">
                            {problem.status}
                          </p>
                        </div>
                      </td>
                      <td className="pr-24">
                        <div className="flex justify-end">
                          <p className="text-sm leading-none text-gray-600 ml-2">
                            {moment(problem.created_at).format("MM/DD/YYYY")}
                          </p>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    )
  );
};
